import axios from 'axios';
import { IAppReducer } from 'models/reducer.interface';
import { store } from 'store/app.store';
import { config } from '../../config/constants';
const storeData: IAppReducer = store.getState();
const accessToken =
  storeData.authReducer.accessToken || storeData.checkoutReducer.accessToken;

const headers = {
  Authorization: 'Bearer ' + accessToken,
};

//Se mejorara en el proximo PR
export default axios.create({
  baseURL: config.merakiApi.url,
  headers,
  responseType: 'json',
});
